import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { formatDate } from "../../../helper/Helper";
import AddDetails from "./AddDetails";
import sportAPI from "../../../api/admin/sportApi";
import EditDetails from "./EditDetails";
import GlobalDeleteModal from "../../../layout/admin/partials/GlobalDeleteModal";
import { showError, showSuccess } from "../../../utils/toastUtils";
import Auth from "../../../utils/AuthUtils";
import MpAPI from "../../../api/admin/mpApi";
import mpSportApi from "../../../api/admin/mpSportApi";
import SelectDetails from "./SelectDetails";

function List() {
  const role = Auth.getUserDetails("roles");

  const [sportData, setSportData] = useState([]); // State for store list
  const [pagination, setPagination] = useState({}); // State for pagination info
  const [searchParams, setSearchParams] = useSearchParams();
  const [editData, setEditData] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showBtn, setShowBtn] = useState(false);

  const [deleteId, setDeleteId] = useState(null);
  const [deleteTable, setDeleteTable] = useState(null);

  useEffect(() => {
    fetchSportData();
  }, [searchParams]);

  const fetchSportData = async () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const limit = parseInt(searchParams.get("limit")) || 10;
    const status = searchParams.get("status") || null;
    const search = searchParams.get("search") || null;

    const res = await sportAPI.getList({
      page,
      limit,
      search,
    });
    if (res.code === 200) {
      setSportData(res.data.items);
      setPagination(res.data.pagination);
    } else {
      setSportData([]);
    }
  };

  const updateFilter = (key, value) => {
    const params = new URLSearchParams(searchParams);
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    setSearchParams(params);
  };

  const handleOpenDeleteModal = (id, table) => {
    setDeleteId(id);
    setDeleteTable(table);
  };

  const handleStatusChange = async (id, status) => {
    try {
      const res = await MpAPI.updateStatus({
        id: id,
        status: status,
        table: "sport",
      });

      if (res.code === 200) {
        showSuccess("Status updated successfully");
        fetchSportData();
      } else {
        showError("Failed to update status");
      }
    } catch (err) {
      showError("Something went wrong");
    }
  };

  const handleCheckboxChange = (e, id) => {
    if (e.target.checked) {
      // push
      setSelectedIds((prev) => [...prev, id]);
    } else {
      // pop/remove
      setSelectedIds((prev) => prev.filter((itemId) => itemId !== id));
    }
  };

  const handleSelectionProcess = async () => {
    const payload = {
      sport: selectedIds,
    };

    const res = await mpSportApi.store(payload);
    if (res.code === 200) {
      showSuccess(res.message);
    } else {
      showError(res.message);
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-flex align-items-center justify-content-between gap-2 mb-4 flex-wrap">
            <div>
              <h4 className="mb-1">
                Sports Selection
                <span className="badge badge-soft-primary ms-2">
                  {pagination.total}
                </span>
              </h4>
              <h6 className="text-muted">
                View, search, and manage all Sports available in your system.
              </h6>
            </div>
            <div className="gap-2 d-flex align-items-center flex-wrap">
              <button
                className="btn btn-primary mt-2 mt-md-0"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
                onClick={() => setShowOffcanvas(true)}
              >
                <i className="ti ti-circle-plus me-1" />
                Add Sport
              </button>

              {role !== "superadmin" && (
                <button
                  className="btn btn-info mt-2 mt-md-0"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasSelectRight"
                  aria-controls="offcanvasSelectRight"
                  onClick={() => setShowOffcanvas(true)}
                >
                  <i className="ti ti-circle-plus me-1" />
                  Select Sport
                </button>
              )}
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="row">
                <div className="col-md-12">
                  <p className="text-muted" style={{ fontSize: "20px" }}>
                    Note: Please Select 8 Games (5 Conventional & 3 Traditional)
                  </p>
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      <i className="ti ti-search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search By Name"
                      value={searchParams.get("search") || ""}
                      onChange={(e) => updateFilter("search", e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-md-9 text-end">
                  {showBtn && (
                    <button
                      className="btn btn-success"
                      onClick={(e) => {
                        handleSelectionProcess();
                      }}
                    >
                      Select Sports
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {pagination.page && (
                <div className="countablepagination p-2">
                  <p>
                    Showing {(pagination.page - 1) * pagination.limit + 1} to
                    {Math.min(
                      pagination.page * pagination.limit,
                      pagination.total
                    )}
                    of {pagination.total} results
                  </p>
                </div>
              )}

              <div className="table-responsive">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th>S. No.</th>
                      <th>Sport Type</th>
                      <th>Sport Name</th>
                      <th>Playing Type</th>
                      <th>Origin</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sportData.length > 0 ? (
                      sportData.map((item, index) => (
                        <tr key={item._id}>
                          <td>
                            {/* <input
                              type="checkbox"
                              onChange={(e) =>
                                handleCheckboxChange(e, item._id)
                              }
                              onClick={(e) => setShowBtn(true)}
                            /> */}
                            {"  "}
                            {((searchParams.get("page") ?? "1") - 1) *
                              (searchParams.get("limit") ?? "10") +
                              index +
                              1}
                            .
                          </td>
                          <td>{item?.gameType?.toUpperCase()}</td>
                          <td>{item?.name}</td>
                          <td>
                            {item.playingType && item.playingType === "team" ? (
                              <span className="badge badge-warning d-inline-flex align-items-center badge-xs">
                                {item?.playingType?.toUpperCase()}
                              </span>
                            ) : (
                              <span className="badge badge-info d-inline-flex align-items-center badge-xs">
                                {item?.playingType?.toUpperCase()}
                              </span>
                            )}
                          </td>
                          <td>{item?.origin?.state}</td>
                          <td>
                            {item.status && item.status === "active" ? (
                              <span className="badge badge-success d-inline-flex align-items-center badge-xs">
                                <i className="ti ti-check me-1" />
                                Active
                              </span>
                            ) : (
                              <span className="badge badge-danger d-inline-flex align-items-center badge-xs">
                                <i className="ti ti-ban me-1" />
                                Inactive
                              </span>
                            )}
                          </td>
                          <td>{formatDate(item.createdAt)}</td>

                          <td className="action-table-data">
                            <div className="edit-delete-action">
                              {item.status && item.status === "active" ? (
                                <button
                                  className="btn btn-sm btn-danger me-2"
                                  onClick={() =>
                                    handleStatusChange(item._id, "deactive")
                                  }
                                >
                                  Deactivate
                                </button>
                              ) : (
                                <button
                                  className="btn btn-sm btn-success me-2"
                                  onClick={() =>
                                    handleStatusChange(item._id, "active")
                                  }
                                >
                                  Activate
                                </button>
                              )}

                              <Link
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasEditRight"
                                aria-controls="offcanvasEditRight"
                                className="me-2 p-2"
                                onClick={() => setEditData(item)}
                              >
                                <i className="ti ti-pencil" />
                              </Link>

                              <a
                                className="p-2"
                                href="javascript:void(0);"
                                data-bs-toggle="modal"
                                data-bs-target="#danger-header-modal"
                                onClick={(e) => {
                                  handleOpenDeleteModal(item._id, "sport");
                                }}
                              >
                                <i className="ti ti-trash" />
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center" }}>
                          No Sport Added
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {pagination.page && (
                  <div className="row">
                    <div className="col-md-6">
                      <div className="page-title p-2">
                        <p className="d-flex" style={{ placeItems: "center" }}>
                          Rows per page:
                          <select
                            className="searchForRows"
                            value={searchParams.get("limit") || ""}
                            onChange={(e) =>
                              updateFilter("limit", e.target.value)
                            }
                          >
                            <option value="10">10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                          entries
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 text-end p-2">
                      <nav
                        aria-label="Page navigation"
                        className="pagination-style-4"
                        style={{ justifyItems: "right" }}
                      >
                        <ul className="pagination mb-0 flex-wrap">
                          {/* Prev Button */}
                          <li
                            className={`page-item ${
                              pagination.page === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link text-primary"
                              disabled={pagination.page === 1}
                              onClick={() =>
                                updateFilter("page", pagination.page - 1)
                              }
                            >
                              Prev
                            </button>
                          </li>

                          {/* Page Numbers */}
                          {[...Array(pagination.totalPages || 1)].map(
                            (_, i) => (
                              <li
                                key={i}
                                className={`page-item ${
                                  pagination.page === i + 1 ? "active" : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => updateFilter("page", i + 1)}
                                >
                                  {i + 1}
                                </button>
                              </li>
                            )
                          )}

                          {/* Next Button */}
                          <li
                            className={`page-item ${
                              pagination.page === pagination.totalPages
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link text-primary"
                              disabled={
                                pagination.page === pagination.totalPages
                              }
                              onClick={() =>
                                updateFilter("page", pagination.page + 1)
                              }
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        {showOffcanvas && <AddDetails onSuccess={fetchSportData} />}
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasSelectRight"
        aria-labelledby="offcanvasSelectRightLabel"
      >
        {showOffcanvas && <SelectDetails onSuccess={fetchSportData} />}
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasEditRight"
        aria-labelledby="offcanvasEditRightLabel"
      >
        {editData && <EditDetails data={editData} onSuccess={fetchSportData} />}
      </div>

      <GlobalDeleteModal
        id={deleteId}
        table={deleteTable}
        onDeleted={fetchSportData}
      />
    </>
  );
}

export default List;
